import { changeImportPage } from './actions/query';
import { getImportPage } from './selectors/query';

const queryParams = {
  importPage: {
    action: changeImportPage,
    defaultValue: 1,
    selector: state => getImportPage(state),
    stringToValue: value => Number(value) || 1
  }
};

export default queryParams;
